import React from "react"
import Cabecalho from "../Cabecalho"
import { Loading } from "../RegistradorDePedidos"
import { IntegracaoPagSeguroForm } from "./components/IntegracaoPagSeguroForm"

export function Index() {
    return (
        <>
            <Cabecalho pagina="Integração PagSeguro" />
            <Loading />
            <IntegracaoPagSeguroForm />
        </>
    )
}
